import { axiosInstance } from '.'
import { AdminWithdrawalUpdatePayload, WithdrawalSearchParamsV1 } from '../lib/types'
import { removeEmptyValueFromObject } from '../lib/utils/helpers'
import {
  GET_WITHDRAWAL_REQUEST_DETAILS_BY_ID_V1,
  SEARCH_WITHDRAWALS_V1,
  UPDATE_WITHDRAWAL_STATUS_V1,
} from './endpoints'

export const withdrawalServices = {
  getWithdrawals: async (params: WithdrawalSearchParamsV1) => {
    try {
      const data = await axiosInstance.get(SEARCH_WITHDRAWALS_V1, {
        params: removeEmptyValueFromObject(params),
      })
      return {
        withdrawals: data.data.withdrawals,
        pagination: {
          count: data.data.count,
          limit: data.data.limit,
          offset: data.data.offset,
          total: data.data.total,
        },
        status: data.status,
        totalWithdrawnAmount: data.data.totalAmount,
      }
    } catch (error: any) {
      return error.response
    }
  },

  getWithdrawalRequestDetails: async (opportunityId: string, investorId: string) => {
    try {
      const data = await axiosInstance.get(
        `${GET_WITHDRAWAL_REQUEST_DETAILS_BY_ID_V1(investorId, opportunityId)}`,
      )

      return { data: data?.data?.withdrawal, status: data.status }
    } catch (error: any) {
      return error.response
    }
  },

  updateWithdrawalStatus: async (withdrawalId: string, payload: Record<string, unknown>) => {
    try {
      const updatePayload: AdminWithdrawalUpdatePayload = {
        status: payload.withdrawalStatus as string,
        quantity: payload.units as number | undefined,
        actualAmountSent: payload.actualAmountSent as number | undefined,
        metadata: payload.metadata as Record<string, unknown> | undefined,
      }
      const data = await axiosInstance.patch(
        UPDATE_WITHDRAWAL_STATUS_V1(withdrawalId),
        removeEmptyValueFromObject(updatePayload),
      )
      return data
    } catch (error: any) {
      return error.response
    }
  },
}
